import React from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import { Button } from '@mui/material';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';

const AllOrderTable = ({ data, activeTab }) => {
  const navigate = useNavigate();
  const tab = activeTab === "Cart order" ? "0" : "1";

  const calculateSubtotal = (partList = []) => {
    return partList.reduce((sum, item) => {
      return sum + (item.quotePrice || 0) * (item.quantity || 0);
    }, 0);
  };

  const calculateTotalGst = (partList = []) => {
    return partList.reduce((sum, item) => {
      const lineTotal = (item.quotePrice || 0) * (item.quantity || 0);
      const gstAmount = lineTotal * ((item.gst || 0) / 100);
      return sum + gstAmount;
    }, 0);
  };

  const calculateTotalAmount = (partList = []) => {
    const subtotal = calculateSubtotal(partList);
    const totalGst = calculateTotalGst(partList);
    return subtotal + totalGst;
  };

  const renderStatusBadge = (status) => {
    const s = (status || '').toUpperCase();
    let bg = '#f1f5f9';
    let color = '#475569';
    if (s === 'NEW') { bg = 'rgba(81, 45, 168, 0.08)'; color = '#512DA8'; }
    else if (s === 'PROCESSING' || s === 'PENDING') { bg = 'rgba(245, 158, 11, 0.1)'; color = '#d97706'; }
    else if (s === 'SHIPPED') { bg = 'rgba(59, 130, 246, 0.1)'; color = '#2563eb'; }
    else if (s === 'DELIVERED') { bg = 'rgba(16, 185, 129, 0.1)'; color = '#10b981'; }
    else if (s === 'CANCELED' || s === 'REJECTED') { bg = 'rgba(239, 68, 68, 0.1)'; color = '#ef4444'; }

    return (
      <span style={{
        backgroundColor: bg,
        color: color,
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600',
        display: 'inline-block'
      }}>
        {s}
      </span>
    );
  };

  return (
    <table className={styles.spectable}>
      <thead>
        <tr>
          <th>Order ID</th>
          <th>Date</th>
          <th>Total</th>
          <th>Status</th>
          <th style={{ textAlign: 'right' }}>Action</th>
        </tr>
      </thead>
      <tbody className={styles.spectbody}>
        {data?.map((record) => (
          <tr key={record._id}>
            <td style={{ fontWeight: '600', color: '#0f172a' }}>
              #{record._id} {record.userId?.fullName ? `(${record.userId.fullName})` : ''}
            </td>
            <td style={{ color: '#64748b' }}>{formateDate(record?.createdAt)}</td>
            <td style={{ fontWeight: '600', color: '#0f172a' }}>
              {activeTab === "Cart order"
                ? `₹${(record?.priceBreakup?.total || 0).toFixed(2)}`
                : `₹${calculateTotalAmount(record?.partList).toFixed(2)}`}
            </td>
            <td>
              {renderStatusBadge(record.status)}
            </td>
            <td style={{ textAlign: 'right' }}>
              <Button
                size="small"
                onClick={() => navigate(`/orderDetails/${record?._id}`, { state: tab })}
                sx={{
                  color: '#512DA8',
                  textTransform: 'none',
                  fontWeight: '600',
                  fontSize: '12px',
                  borderRadius: '6px',
                  '&:hover': {
                    background: 'rgba(81, 45, 168, 0.06)'
                  }
                }}
              >
                View Details
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AllOrderTable;
